/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetAnimalCareSummaryQueryResponse, GetAnimalCareSummaryPathParams, GetAnimalCareSummary400, GetAnimalCareSummary401, GetAnimalCareSummary403, GetAnimalCareSummary404, GetAnimalCareSummary409, GetAnimalCareSummary500 } from "../../types/livestockController/GetAnimalCareSummary.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetAnimalCareSummaryUrl(organizationId: GetAnimalCareSummaryPathParams["organizationId"], animalId: GetAnimalCareSummaryPathParams["animalId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/livestock/animals/${animalId}/care` as const }
  return res
}

/**
 * @summary Sanitary summary for an animal: meat withdrawal standing, last deworming / ectoparasite control, open diseases, recent treatments, upcoming items and nutrition
 * {@link /api/organizations/:organizationId/livestock/animals/:animalId/care}
 */
export async function getAnimalCareSummary(organizationId: GetAnimalCareSummaryPathParams["organizationId"], animalId: GetAnimalCareSummaryPathParams["animalId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetAnimalCareSummaryQueryResponse, ResponseErrorConfig<GetAnimalCareSummary400 | GetAnimalCareSummary401 | GetAnimalCareSummary403 | GetAnimalCareSummary404 | GetAnimalCareSummary409 | GetAnimalCareSummary500>, unknown>({ method : "GET", url : getGetAnimalCareSummaryUrl(organizationId, animalId).url.toString(), ... requestConfig })
  return res.data
}